import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
//import HtlFloorPartEdit from "./HtlFloorPartEdit";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import { InputSwitch } from "primereact/inputswitch";




const GET_POST = gql`
query MyQuery(
    $accId: Int
    $accEntId: Int
    $accType: String
    $accCode: String
    $sourceCode: String
    $sourceType: String

    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_acc_ent(where: {

        acc_ent_id: { _eq: $accEntId }
      
      
       firm_main_code: { _eq: $ownFirmCode }
       firm_sub_code: { _eq: $ownFirmSubCode }         
        
        
    }) {
        acc_id
        acc_ent_id
        acc_type
        acc_code
        source_code
      firm_main_code
      firm_sub_code
      source_type
      opr_filter
      opr_filter_gnl
      card_value
        
  }
  
}
`;




const INSERT_SEA = gql`
  mutation InsertRules(
  
    $accId: Int
    $accEntId: Int
    $accType: String
    $accCode: String
    $sourceCode: String
    $sourceType: String
    $optFilter: String
    $optFilterGnl: String
    $cardValue: Int
    $ownFirmCode: String
    $ownFirmSubCode: String

   
    
  ) {
    insert_tbl_acc_ent(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        acc_id: $accId,  
        acc_ent_id: $accEntId,
        acc_type: $accType,
        acc_code: $accCode,

        source_code: $sourceCode      
        source_type: $sourceType  
        opr_filter: $optFilter
       
        opr_filter_gnl: $optFilterGnl
        card_value: $cardValue
       
       

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_RULES_CLS = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;


const GET_RULES_PRE = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const GET_RULES_OPR = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const GET_RULES_TIME = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;



const UPDATE_RULES = gql`
mutation UpdateRules(

    $accId: Int
    $accEntId: Int
    $accType: String
    $accCode: String
    $sourceCode: String
    $sourceType: String
    $optFilter: String
    $optFilterGnl: String
    $cardValue: Int
    $ownFirmCode: String
    $ownFirmSubCode: String

    
  ) {
    update_tbl_acc_ent(
      where: {
            acc_ent_id: { _eq: $accEntId }
           
            firm_main_code: { _eq: $ownFirmCode }
            firm_sub_code: { _eq: $ownFirmSubCode }      
      }
      _set: {


   
        
        
        card_value: $cardValue      
        opr_filter_gnl: $optFilterGnl  
        opr_filter: $optFilter
        acc_code: $accCode
        acc_type: $accType
        
       
       
       
      }
    ) {
      affected_rows
    }
  }
`; 




const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;



const GET_MAIN_DPR_M = gql`
  query MyQuery($ownFirmCode: String, $ownFirmSubCode: String) {
    tbl_gnl_cards(
      where: {
       
        gnl_type: { _eq: TAX }
       
      }
    ) {
      firm_main_code
      firm_sub_code
      gnl_card_code
      gnl_card_name
      gnl_type
    }
  }
`;

const GET_SUB_DPR_M = gql`
  query MyQuery($ownFirmCode: String!, $ownFirmSubCode: String, $dprMainM: String) {
    tbl_dpr_sub(
      where: {
        firm_main_code: { _eq: $ownFirmCode },
        firm_sub_code: { _eq: $ownFirmSubCode },
        dpr_main_code: { _eq: $dprMainM },
       
      }
    ) {
      firm_main_code
      firm_sub_code
      dpr_main_code
      dpr_sub_code
      dpr_sub_name
    }
  }
`;

const GET_MAIN_WARE_M = gql`
query MyQuery($drctype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drctype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_SUB_WARE_M = gql`
query MyQuery($drctype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drctype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const GET_RCLASS = gql`
  query MyQuery($drctype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drctype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const GET_RTTYPE = gql`
  query MyQuery($drttype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drttype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;






const HtlProdTaxEdit = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode11, setVarCode11} = useContext(ThemeContext);
   const {varCode12, setVarCode12} = useContext(ThemeContext);
   const {varCode13, setVarCode13} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

 
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { 
         ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, 
         accId: varCode8, accType: varCode10, accCode: varCode9, sourceCode: varCode11,
          sourceType: varCode12, accEntId: varCode13 },
  });




  const firmData = data && data.tbl_acc_ent ? data.tbl_acc_ent[0] : null;
  //const firmData2 = data && data.tbl_rules_sub_premises ? data.tbl_rules_sub_premises[0] : null;
 

  const [updateRulesSub] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  const [rulExitIdTrg, setRulExitIdTrg] = useState("");  


  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState(""); 
 const [rulExitId, setRulExitId] = useState(firmData ? firmData.acc_id : "");   
 const [accId, setAccId] = useState(firmData ? firmData.acc_id : "1");  
 const [accEntId, setAccEntId] = useState(firmData ? firmData.acc_ent_id : "");  
 const [accType, setAccType] = useState(firmData ? firmData.acc_type : "ACARD");  
 const [accCode, setAccCode] = useState(firmData ? firmData.acc_code : "");  
 const [sourceCode, setSourceCode] = useState(firmData ? firmData.source_code : varCode11); 
 const [sourceType, setSourceType] = useState(firmData ? firmData.source_type : varCode12);   
 const [optFilter, setOptFilter] = useState(firmData ? firmData.opr_filter : "");  
 const [optFilterGnl, setOptFilterGnl] = useState(firmData ? firmData.opr_filter_gnl : "");  
 const [cardValue, setCardValue] = useState(firmData ? firmData.card_value : 0);  

 
 
 const [rulSubId, setRulSubnId] = useState(firmData ? firmData.build_plan_id : "");  
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.build_id : ""); 
  const [rulPremId, setRulPremId] = useState(firmData ? firmData.floor_map_id : ""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.name : ""); 
  const [actType, setActType] = useState(firmData ? firmData.fp_type : ""); //act Type Dısk- Pay - Inv
  const [actPremType, setActPremType] = useState(firmData ? firmData.status : ""); // date- rez- check-in - checkout
  const [actPremType2, setActPremType2] = useState(firmData ? firmData.pre_type_2 : "");
  const [actStrV1, setActStrV1] = useState(firmData ? firmData.str_var_1 : ""); // % , CUR , etc disk type
  const [actStrV2, setActStrV2] = useState(firmData ? firmData.str_var_2 : ""); // day - hour - min
  const [actIntV1, setActIntV1] = useState(firmData ? firmData.opt_3 : "0"); // % , CUR , etc disk value
  const [actIntV2, setActIntV2] = useState(firmData ? firmData.factor : "0"); // Str1 Value rez date 5 day
  const [actOpr1, setActOpr1] = useState(firmData ? firmData.opr_1 : ""); // 
  const [date1, setDate1] = useState(firmData ? new Date(firmData.date_1): new Date());


  const [dprMainM, setDprMainM] = useState(firmData ? firmData.dpr_main_code: "");
  const [dprSubM, setDprSubM] = useState(firmData ? firmData.dpr_sub_code: "");
  const [warehMainM, setWarehMainM] = useState(firmData ? firmData.wareh_main_code: "");
  const [warehSubM, setWarehSubM] = useState(firmData ? firmData.wareh_sub_code: "");

  const [rClassName, setRClassName] = useState(firmData ? firmData.r_class_name : "");
  const [rClassCode, setRClassCode] = useState(firmData ? firmData.opt_1 : "");
  const [rTypeCode, setRTypeCode] = useState(firmData ? firmData.opt_2 : "");
  const [rTypeName, setRTypeName] = useState(firmData ? firmData.r_type_name : "");
  const [active, setActive] = useState(firmData ? firmData.active : true);

  
  
  

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const select_rule_result_hint = messages[currentLocale].select_rule_result_hint;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const rule_persent_title = messages[currentLocale].rule_persent_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const rule_type_name_title = messages[currentLocale].rule_type_name_title;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const when_title = messages[currentLocale].when_title;
  const value_title = messages[currentLocale].value_title;
  const calcutate_title = messages[currentLocale].calcutate_title;
  const new_result_btn = messages[currentLocale].new_result_btn;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const typerec = messages[currentLocale].typerec;


  



  const close_form = messages[currentLocale].close_form;
 
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const sea_new_btn = messages[currentLocale].sea_new_btn;
  const sea_Season_title = messages[currentLocale].sea_Season_title;
  
 
  const sea_management_title = messages[currentLocale].sea_management_title;
  const detail = messages[currentLocale].detail;
  
  const sea_id_title = messages[currentLocale].sea_id_title;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const sea_desc_title = messages[currentLocale].sea_desc_title;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_RULES_CLS, {
    variables: {lang: currentLocale, defType: "FLRPR", },
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_RULES_PRE, {
    variables: {lang: currentLocale, defType: "PREMA" },
  });

  const { loading: defLoading3, error: defError3, data: defData3 } = useQuery(GET_RULES_OPR, {
    variables: {lang: currentLocale, defType: "OPR" },
  });

  const { loading: defLoading4, error: defError4, data: defData4 } = useQuery(GET_RULES_TIME, {
    variables: {lang: currentLocale, defType: "CTYPE" },
  });

  const { loading: dprmmLoading, error: dprmmError, data: dprmmData } = useQuery(GET_MAIN_DPR_M, {
    variables: { ownFirmCode:  ownFirmCode, ownFirmSubCode: ownFirmSubCode},
  });

  const { loading: dprsmLoading, error: dprsmError, data: dprsmData } = useQuery(GET_SUB_DPR_M, {
    variables: { ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, dprMainM: dprMainM},
  });

    const { loading: warehmmLoading, error: warehmmError, data: warehmmData } = useQuery(GET_MAIN_WARE_M, {
    variables: { ownFirmCode:  ownFirmCode, ownFirmSubCode: ownFirmSubCode,  drctype: "ETYPE", lang: currentLocale},
  });

  const { loading: warehsmLoading, error: waresmError, data: warehsmData } = useQuery(GET_SUB_WARE_M, {
    variables: { ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, drctype: "ETYPE"},
  });

  const { loading: drtLoading, error: drtError, data: drtData } = useQuery(GET_RTTYPE, {
    variables: { drttype: 'RTYP', lang: currentLocale },
  });

  const { loading: drcLoading, error: drcError, data: drcData } = useQuery(GET_RCLASS, {
    variables: { drctype: "RCLS", lang: currentLocale },
  });




  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (rulExitIdTrg !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [rulExitIdTrg, setRulExitIdTrg]);



  

  useEffect(() => {
    if (firmData) {        
        setAccId(firmData.acc_id);  
        setAccEntId(firmData.acc_ent_id);  
        setAccType(firmData.acc_type);  
        setAccCode(firmData.acc_code);
        setOptFilter(firmData.opr_filter);
        setOptFilterGnl(firmData.opr_filter_gnl);
        setSourceCode(firmData.source_code);
        setSourceType(firmData.source_type);
        setCardValue(firmData.card_value);

        


       
       
        
     
          
    }
  }, [firmData]);




  const handleUpdate = () => {
   
    
    updateRulesSub({
      variables: {    
        
            
        accId: accId,
        accEntId: accEntId,
        accType: accType,
        accCode: accCode,      
        optFilter: optFilter,
        
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,        
        optFilterGnl: optFilterGnl,

        sourceCode: sourceCode,
        sourceType: sourceType,
        cardValue: cardValue,
       
      
      


        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['accType' ]; // Required fiels
    const customFieldNames = {
      rulesName: "Offer Name",
    //  ruleClass: "Rules Class",
      accType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setRulExitIdTrg(updatedIdSeq); 
        setAccEntId(updatedIdSeq); 
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulExitIdTrg);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {


        accId: accId,
        accEntId: accEntId,
        accType: accType,
        accCode: accCode,      
        optFilter: optFilter,
        
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,        
        optFilterGnl: optFilterGnl,

        sourceCode: varCode11,
        sourceType: varCode12,
        cardValue: cardValue,
      

  
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
        setRulExitIdTrg(''); 
        refetch();
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
  //  setVarCode11(ruleType); //EBO
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
   // setVarCode10(0);  
   // setVarCode11(ruleType); //EBO
    setVarCode10(0); //EBO
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const rulesClasstems = defData && defData.tbl_gnl_def
  ? defData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const rulesClasstems2 = defData2 && defData2.tbl_gnl_def
  ? defData2.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const rulesClasstems3 = defData3 && defData3.tbl_gnl_def
  ? defData3.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const rulesClasstems4 = defData4 && defData4.tbl_gnl_def
  ? defData4.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];




  const dprMainMItems = dprmmData && dprmmData.tbl_gnl_cards
  ? dprmmData.tbl_gnl_cards.map(item => ({
      label: item.gnl_card_name,
      value: item.gnl_card_code,
      name: item.gnl_card_name, 
    }))
  : [];

  const dprSubMItems = dprsmData && dprsmData.tbl_dpr_sub
  ? dprsmData.tbl_dpr_sub.map(item => ({
      label: item.dpr_sub_name,
      value: item.dpr_sub_code,
      name: item.dpr_sub_name, 
    }))
  : [];


    const warehMainMItems = warehmmData && warehmmData.tbl_gnl_def
  ? warehmmData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const warehSubMItems = warehsmData && warehsmData.tbl_dpr_sub
  ? warehsmData.tbl_dpr_sub.map(item => ({
      label: item.dpr_sub_name,
      value: item.dpr_sub_code,
      name: item.dpr_sub_name, 
    }))
  : [];



  const roomClassSelectItemsC = drcData && drcData.tbl_gnl_def
  ? drcData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const roomClassSelectItems = drtData && drtData.tbl_gnl_def
  ? drtData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   



    
    <div className=" p-2 ">
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">
      <div className="flex gap-4">
          <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={accId}
    onChange={(e) => setAccId(e.target.value)}
    readOnly
    />
  </div>  
  
  <div className="w-1/8 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Type"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={accType} 
    onChange={(e) => setAccType(e.target.value)} autoComplete="off"/>
    
  </div>


  <div>
        <label htmlFor="roomClassDropdown" className="font-medium flex  text-gray-700">
        {"Traditional Place"}
       </label>
       <Dropdown
       className="h-11  w-3/8 rounded-md" // Bu satır eklenmiştir
     //   style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={actType}
         options={rulesClasstems}
         onChange={(e) => setActType(e.value)}
         placeholder={"Select Traditional Point"}
         />
       </div> 

       <div className="w-full p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_class_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={sourceType} 
    onChange={(e) => setSourceType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-full p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Source"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={sourceCode} 
    onChange={(e) => setSourceCode(e.target.value)} autoComplete="off"/>
    
  </div>
 
  </div>  

  
</p>
   </Fieldset>
       </div>

     

       <Fieldset>
             <p className="my-0  ">   

             

      <div className="flex gap-4">
           <div className="w-20 p-inputtext-sm  flex-column gap-3">
           <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
           htmlFor="username">  {"code"}</label>
           <InputText className="w-full" 
          id="username" value={optFilterGnl} 
          onChange={(e) => setOptFilterGnl(e.value)}
           />
          </div>

         <div>
        <label htmlFor="roomClassDropdown" className="font-medium flex  text-gray-700">
        {"code"}
        </label>
       <Dropdown
       className="h-11  w-full rounded-md" // Bu satır eklenmiştir
        style={{ width: '284px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={optFilterGnl}
         options={warehMainMItems}
         onChange={(e) => setOptFilterGnl(e.value)}
         placeholder={"select_a_department_holder"}
         />
       </div>

  

       <div className="w-20 p-inputtext-sm  flex-column gap-3">
           <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {"Sub Class"}</label>
         <InputText className="w-full" 
         id="username" value={optFilter}
         onChange={(e) => setOptFilter(e.value)}
         />
          </div>

         <div>
         <label htmlFor="roomClassDropdown" className="font-medium flex text-gray-700">
              {"sub_Sub Class"}
              </label>
              <Dropdown
              className="h-11  w-full rounded-md" // Bu satır eklenmiştir
            //  style={{ width: '354px' }} 
              dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
              <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
               </svg>}
              value={optFilter}
              options={rulesClasstems4}
              onChange={(e) => setOptFilter(e.value)}
              placeholder={"select_a_department_holder"}
              />
       </div>

      </div>

      <div className="flex gap-4">
           <div className="w-20 p-inputtext-sm  flex-column gap-3">
           <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
           htmlFor="username">  {"Acc Type"}</label>
           <InputText className="w-full" 
          id="username" value={accCode} 
          onChange={(e) => setAccCode(e.value)}
           />
          </div>

         <div>
        <label htmlFor="roomClassDropdown" className="font-medium flex  text-gray-700">
        {"Acc Type"}
        </label>
       <Dropdown
       className="h-11  w-full rounded-md" // Bu satır eklenmiştir
        style={{ width: '284px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={accCode}
         options={dprMainMItems}
         onChange={(e) => setAccCode(e.value)}
         placeholder={"select_a_department_holder"}
         />
       </div>

       <div className="w-20 p-inputtext-sm  flex-column gap-3">
           <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {"Value"}</label>
         <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={cardValue}
                  onValueChange={(e) => setCardValue(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  
                />                
          </div>


      </div>


      



</p>
   </Fieldset>
    
 
       </div>  

       




{actType === "ROOM" && (

<Fieldset>
      <p className="my-0  ">   

<div className="flex gap-3 ">

<div className="mr-2 w-20">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"Class"}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rClassCode}
      onChange={(e) => setRClassCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block  font-medium text-gray-700">
      {"Room Class"}
    </label>
    <Dropdown
      className="h-11  w-56 md:w-56 mr-2 rounded-md"
      style={{ width: '314px' }} 
      value={rClassCode}
      options={roomClassSelectItemsC}
      onChange={(e) => setRClassCode(e.value)}
      placeholder={"select_a_room_class"}
    />
  </div>

  <div className="mr-2 w-20">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {typerec}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rTypeCode}
      onChange={(e) => setRTypeCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {"Room Type"}
    </label>
    <Dropdown
      className="h-11 w-1/8 rounded-md"
      style={{ width: '314px' }} 
      value={rTypeCode}
      options={roomClassSelectItems}
      onChange={(e) => setRTypeCode(e.value)}
      placeholder={"select_a_room_type"}
    />
  </div>
 

</div>



</p>
</Fieldset>
)}   {/* ROOM  */}

{actType === "SPPC" && (

<Fieldset>
      <p className="my-0  ">   

<div className="flex gap-3 ">


<div className="w-1/6 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_persent_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={actIntV1} 
onChange={(e) => setActIntV1(e.target.value)} autoComplete="off"/>

</div>
<div className="w-1/6 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_persent_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={actIntV2} 
onChange={(e) => setActIntV2(e.target.value)} autoComplete="off"/>

</div>

<div className="w-1/3 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_type_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={rulesName} 
onChange={(e) => setRulesName(e.target.value)} autoComplete="off"/>

</div>



</div>


</p>
</Fieldset>
)}   {/* SPPC  */}

    <div className="flex justify-end mt-2 gap-4 ">  
  
  <div className="w-1/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-1/4">
    <Button
      label={new_result_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div> 
  
  </div>
    
    
    
 
 
);
};

export default HtlProdTaxEdit;
